// custom functions
const FE = {
	location: window.location,

    Lightbox: {
        init: function () {
            const parvus = new Parvus({
                captionsAttribute: 'title'
            });
        }
    },

    MobileMenu: {
        burgerIcon: null,
        navMain: null,
        init: function() {
            this.indicateSubMenu();
            this.burgerIcon = document.getElementById('burger-icon');
            this.navMain = document.getElementById('nav-main');

            const mobileMenuOverlay = document.createElement('div');
            mobileMenuOverlay.id = 'mobile-menu-overlay';
            mobileMenuOverlay.classList.add('mobile-menu-overlay');
            mobileMenuOverlay.addEventListener('click', FE.MobileMenu.hide);

            document.body.append(mobileMenuOverlay);

            this.burgerIcon.addEventListener('click', function (e) {
                if (FE.MobileMenu.navMain.classList.contains('active')) {
                    FE.MobileMenu.hide();
                } else {
                    FE.MobileMenu.show();
                }
            });
        },
        show: function () {
            FE.MobileMenu.burgerIcon.setAttribute('aria-expanded', 'true');
            FE.MobileMenu.navMain.classList.add('active');
            document.body.classList.add('mobile-menu-open');
        },
        hide: function () {
            FE.MobileMenu.burgerIcon.setAttribute('aria-expanded', 'false')
            FE.MobileMenu.navMain.classList.remove('active');
            document.body.classList.remove('mobile-menu-open');
        },
        indicateSubMenu: function() {
            document.querySelectorAll('.nav-main li').forEach(function (menuItem) {
                if (menuItem.querySelector('ul')) {
                    const button = document.createElement('button');
                    button.classList.add('open-sub');
                    button.setAttribute('aria-label', 'öffnen');
                    button.setAttribute('aria-expanded', 'false')
                    button.addEventListener('click', FE.MobileMenu.handleSubMenuButtonClick);
                    menuItem.querySelector('a').after(button);
                }
            });
        },
        handleSubMenuButtonClick: function (e) {
            if (e.currentTarget.parentElement.classList.contains('open')) {
                FE.MobileMenu.closeSubMenu(e);
            } else {
                FE.MobileMenu.openSubMenu(e);
            }
        },
        openSubMenu: function (e) {
            e.currentTarget.setAttribute('aria-expanded', 'true');
            e.currentTarget.parentElement.classList.add('open');
        },
        closeSubMenu: function (e) {
            e.currentTarget.setAttribute('aria-expanded', 'false');
            e.currentTarget.parentElement.classList.remove('open');
        }

    },

    HeroSlider: {
        init: function () {
            var sliderContainer = document.querySelector('.ce-hero-slider-slides');
            var slides = document.querySelectorAll('.ce-hero-slider-slides figure');
            //console.log(sliderContainer, slides);
            this.setupSliderMarkup(sliderContainer, slides);
        },
        setupSliderMarkup: function (sliderContainer, slides, controls=false) {
            var sliderEl = document.createElement('div');
            var sliderTrack = '<div class="glide__track" data-glide-el="track"></div>';
            var sliderControls ='<div class="glide__arrows" data-glide-el="controls"><button class="glide__arrow glide__arrow--left" data-glide-dir="<">prev</button><button class="glide__arrow glide__arrow--right" data-glide-dir=">">next</button></div>';

            var slidesCount = slides.length;
            for (var i=0; i < slidesCount; i++) {
                slides[i].classList.add('glide__slide');
            }

            sliderEl.classList.add('glide');
            sliderContainer.parentNode.insertBefore(sliderEl, sliderContainer);
            sliderContainer.classList.add('glide__slides');

            var sliderInnerContent = sliderTrack;
            if (controls === true) {
                sliderInnerContent += sliderControls;
            }
            sliderEl.innerHTML = sliderInnerContent;

            var sliderTrackEl = sliderEl.querySelector('.glide__track');
            sliderTrackEl.appendChild(sliderContainer);

            new Glide('.ce-hero-slider .glide', {
                type: 'carousel',
                autoplay: 4000,
                hoverpause: true
            }).mount();
        }
    },

};

// init custom functions
window.addEventListener("DOMContentLoaded", function () {

    FE.MobileMenu.init();
    if ( document.querySelectorAll('.lightbox').length ) {
        FE.Lightbox.init();
    }
    if ( document.querySelectorAll('.ce-hero-slider-slides figure').length > 1 ) {
        FE.HeroSlider.init();
    }
});